import React     from 'react';
import PropTypes from 'prop-types';

import * as S            from './../tile-coterm/coterm-tile.module.scss';

// Components
import { ProductName } from '../../../common/product/prod-name';
import { TagLine }     from '../../../common/product/tag-line';
import { Price }       from '../../../common/product/price';
import { Quota }       from '../../../common/product/quota';

// Selectors
import * as ProductSelectors from '../../../../context/selectors/product-selectors';

// Context Functions
import { useGlobalCtx }    from '../../../../context/ctx-hook';

// Helpers
import * as TimeHelpers    from '../../../../helpers/time-helpers';


const SkuProductRow = ({sku, expiryText, testId}) => {
  const { state } = useGlobalCtx();
  const expiryMessage = expiryText ? expiryText : 'Renews On';
  const skuData = state.skus[sku];
  const productLogo = ProductSelectors.getProductLogo(skuData.ProductLine);
  const isBm = skuData?.ProductLine === 'billmanager';
  const ExpiryDate = TimeHelpers.skuRenewalTermFromToday(skuData.RenewalFrequencyISODuration);
  // console.log('sku:', sku);
  // console.log('skuData:', skuData);
  // console.log('skuData.ProductLine:', skuData.ProductLine);
  // console.log('skuData.Tier:', skuData.Tier);
  // console.log('______________');

  return (
    <div className={S.subTileContain}>
      <div className={S.subTileLeft}>
        <div className={S.productRow}>
          <img className={S.rowLogo} alt="square product logo" src={productLogo}></img>
          <div className={S.productName}>
            <div className={S.productTitle}>
              {skuData?.ProductLine === 'billmanager' ?
                <ProductName product={skuData?.ProductLine} customName={skuData?.display_name} className={S.productName} nameStyle='inline' />
                :<ProductName product={skuData?.ProductLine} customName={skuData?.Tier} className={S.productName} nameStyle='inline' />
              }

            </div>

            <TagLine uriName={skuData.Tier} className={S.tagLine} />

            {isBm &&
              <Quota sku={sku} quotaData={skuData?.Quota} />
            }
          </div>
        </div>
      </div>

      <div className={S.subTileRight}>
        <Price
          renewalFrequency={skuData?.RenewalFrequencyISODuration}
          sku={sku}
          className={S.currentPrice}
        />


        <div className={S.purchaseExpiry} data-testid="SUB_EXPIRY">{expiryMessage} {ExpiryDate}</div>

      </div>
    </div>
  );
};


SkuProductRow.displayName  = 'SkuProductRow';
SkuProductRow.propTypes    = {
  sku: PropTypes.string.isRequired,
  testId:  PropTypes.string,
  expiryText: PropTypes.string
};
SkuProductRow.defaultProps = {
  isModal: false,
  subs: []
};

export { SkuProductRow };